<div class="my-2">
  <div class="form-check form-check-inline ps-0">
    <form [formGroup]="formData">
      <div
        class="form-check"
        style="
          padding: 9px 20px 9px 33px;
          border-radius: 4px;
          border: 1px solid rgb(220 223 230);
        ">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="field" />
        <label class="form-check-label">{{
          group.name === 'relative' ? question.label + '?' : question.label
        }}</label>
      </div>
    </form>
  </div>
</div>
